import { useDispatch } from 'react-redux'
import { useMemo } from 'react'
import { bindActionCreators } from '@reduxjs/toolkit'

import { mainSliceAction } from '../store/mainSlice.js'
import {matchSliceAction} from "../store/matchSlice";
import {playerSliceAction} from "../store/playerSlice";

const rootActions = {
  ...mainSliceAction,
  ...matchSliceAction,
  ...playerSliceAction
}

export const useAction = () => {
  const dispatch = useDispatch()

  return useMemo(() => bindActionCreators(rootActions, dispatch), [dispatch])
}
